<template>
	<div class="page">
		<div class="login-logo text-center">
			<img src="/img/logo/grafias_medium_ondark.png" class="d-inline-block m-auto" loading="lazy" alt="Grafias">
		</div>
		<div class="message-box text-center">
			<h3 class="mb-5">{{ $t('Performing something') }}</h3>
			<div class="text-lg mb-4">Please wait for a few seconds, we will redirect you to your dashboard</div>
		</div>
	</div>
</template>

<script>
import { TOKEN_KEY } from '@/lib/statics';
import client from '@/lib/http-client';
import auth from '@/api/auth';

export default {
	name: 'AutoLogin',
	data() {
		return {
			isValidating: false,
		};
	},
	methods: {
		validateToken() {
			this.isValidating = true;
			const params = {
				token: this.token,
				lang: 'en',
			};
			const callback = (response) => {
				const message = response.message;
				const jwt = response.data.token;
				localStorage.setItem(TOKEN_KEY, jwt);
				client.defaults.headers.Authorization = `Bearer ${jwt}`;
				this.$router.push('/').catch(() => {});
				this.isValidating = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Auto Login',
					text: message,
				});
			};
			const errorCallback = () => {
				this.isValidating = false;
			};
			auth.autoLogin(params, callback, errorCallback);
		},
	},
	computed: {
		token() {
			const { token } = this.$route.query;
			return token;
		},
	},
	created() {
		this.validateToken();
	},
};
</script>
